import { ApiEndpointTags } from '../imago-mp.types';
import type { Addon, AddonApiItem } from './subscriptions-query';
import { transformAddon } from './subscriptions-query';

export type CreateAddonInput = {
    /**
     * The addon CRUD endpoint is registered with incomingSubscriptionId, so
     * the owning subscription must be sent in the body rather than derived
     * from the session user.
     */
    subscriptionId: string;
    name: string;
    type: string;
    quantity: number;
    salesforceQuoteNumber: string;
    notes: string;
    startDate: string;
    finishDate: string;
};

type CreateAddonResponse = {
    addon?: AddonApiItem;
};

export const createAddonMutation = {
    query: ({ startDate, finishDate, ...fields }: CreateAddonInput) => ({
        url: '/mp/1/addons',
        method: 'post',
        body: {
            addon: {
                ...fields,
                // startDate/finishDate are Postgres timestamp columns; ''
                // (open-ended) is invalid timestamp syntax, so send null.
                startDate: startDate || null,
                finishDate: finishDate || null,
            },
        },
    }),
    transformResponse: (response: CreateAddonResponse): Addon => {
        const addon = response?.addon ?? {};
        return transformAddon({ ...addon, id: addon.id ?? '' });
    },
    invalidatesTags: (_result: Addon | undefined, _error: unknown, arg: CreateAddonInput) => [
        { type: ApiEndpointTags.Subscription, id: arg.subscriptionId },
    ],
};
